import { useGetFieldsGeometryQuery, useGetRoutesQuery } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { selectRoutesWithoutTaskFilters } from 'app/containers/Task/slice/selectors';
import { useSelector } from 'react-redux';

export const useLoadRoutesWitoutTaskData = () => {
  const envId = useSelector(selectSelectedEnvId) as number;
  const seasonId = useSelector(selectSelectedSeasonId) as number;
  const filters = useSelector(selectRoutesWithoutTaskFilters);

  useGetRoutesQuery({
    envId,
    filters,
    routesInFieldsOnly: true,
  });

  useGetFieldsGeometryQuery({
    envId,
    seasonId,
    companyId: null,
    companyGroupId: null,
  });
};
